import styled, { css } from 'styled-components';

import { color } from '../../../atoms/colors';
import { font } from '../../../atoms/typography';
import { spacing } from '../../../atoms/spacing';

const themeMap = {
  green: css`
    background: linear-gradient(
        141deg,
        rgba(199, 220, 252, 0.2) 27.87%,
        rgba(255, 255, 255, 0) 87.35%
      ),
      #f2faf5;
  `,
  blue: css`
    background: linear-gradient(
        141deg,
        rgba(199, 220, 252, 0.2) 27.87%,
        rgba(255, 255, 255, 0) 87.35%
      ),
      #f2f6fc;
  `,
};

export const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: ${spacing[12]};
`;

export const Column = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${spacing[12]};

  p {
    ${font('text', 'md', '600')}
    color: ${color.darkBlue[1000]};
  }

  a {
    width: 100%;
  }
`;

export const Card = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: ${spacing[24]};
  padding: ${spacing[22]};
  border-radius: ${spacing[12]};
  box-shadow: 0px 2px 4px -2px rgba(16, 24, 40, 0.06),
    0px 4px 8px -2px rgba(16, 24, 40, 0.1);
  ${({ theme }) => themeMap[theme]}
`;

export const Text = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing[12]};

  .heading {
    ${font('text', 'xl', '600')}
    color: ${color.darkBlue[1000]};
  }

  .subhead {
    ${font('text', 'md', '400')}
    color: ${color.darkBlue[600]};
  }
`;
